import { ModalState } from './-types'

export default (): ModalState => ({
  modalType: '',
  showModal: false,
  data: null
})
